import { AiOutlineGoogle } from 'react-icons/ai';
import { Logo } from '@/components/Logo';
import { PlatformIcon } from '@/components/PlatformIcon';
import { PlatformTypes } from '@/types/gql.generated';
import { Icon } from '@/ui';
import type { FeedIconType } from './feedType';

type Props = {
  iconType: FeedIconType;
  /** Rendered size in pixels. */
  size?: number;
};

// Brand/source icon for a feed type: the Google "G" for Google calendars, the
// grayscale Agenda Hero mark for experience-backed feeds, and the RSS glyph for
// ICS calendar feeds.
export const FeedTypeIcon = ({ iconType, size = 13 }: Props) => {
  if (iconType === 'google') {
    return <AiOutlineGoogle size={size} />;
  }
  if (iconType === 'outlook') {
    return (
      <PlatformIcon platform={PlatformTypes.OutlookIntegration} size={size} />
    );
  }
  if (iconType === 'logo') {
    return <Logo height={size} variant="black" />;
  }
  return <Icon icon="Rss" size={`${size}px`} />;
};
